export default __webpack_public_path__ + "static/media/paroisse_saint_jean_de_montmartre.50dffc6c.jpg";